module.exports = __webpack_public_path__ + "images/764cac497ad24eca7bb96f966bf029d4-donuts.png";